export type PreviewPage = {
  src: string;
  alt: string;
};

export const previewPages: PreviewPage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/dQ5FaRbvjmSaGdvYQXWrhr/PAGINA_9.jpg',
    alt: 'Sample page A Feedback Loop Has Four Blocks, showing the anatomy of a feedback control loop: process, transmitter, controller and final control element',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/1fXmactRR5A3D9SuiqvMji/PAGINA_18.jpg',
    alt: 'Sample page The Process Answers Late and Slowly, explaining the step response with steady-state gain, dead time and time constant',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/pz5yNpFvkcEPSHd1KiPth6/PAGINA_22.jpg',
    alt: 'Sample page Three Numbers Describe Most Loops, a worked example of the first-order-plus-dead-time (FOPDT) model',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/pLqh9WYzESbJ8MCPeVjJaH/PAGINA_34.jpg',
    alt: 'Sample page The Trim Decides How Flow Follows Travel, comparing linear, equal percentage and quick opening valve characteristics',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/oFK31X5nxnJfRXYvgQL65m/PAGINA_50.jpg',
    alt: 'Sample page Process Control Fundamentals Field Card, a checklist covering the loop, the signal, the process, the numbers and the final element',
  },
];
